export default __webpack_public_path__ + "static/complete-7f380f7ce518f79ffc9b82911764627f.webp";